import apiService from './ApiService';

export default class WaitlistApiService {
    /**
     * Get the storage sizes available to waitlist at a facility
     * @param facilityId {number}
     * @returns {Promise<ServiceResponse<Array<string>>>}
     */
    async getAvailableSizes(facilityId) {
        const response = await apiService.getData(`/api/Waitlist/facilities/${facilityId}/sizes`);
        return response?.data;
    }

    /**
     * Join the waitlist for a given facility + storage size
     * @param facilityId {number}
     * @param storageSize {string}
     * @returns {Promise<ServiceResponse<WaitlistEntryDTO>>}
     */
    async join(facilityId, storageSize) {
        const response = await apiService.postData('/api/Waitlist', { facilityId, storageSize });
        return response?.data;
    }

    /**
     * Get the current user's waitlist entries (with pending offer, if any)
     * @returns {Promise<ServiceResponse<Array<WaitlistEntryDTO>>>}
     */
    async getMyEntries() {
        const response = await apiService.getData('/api/Waitlist/me');
        return response?.data;
    }

    /**
     * Leave a waitlist entry. If the entry has a pending offer, it will be declined.
     * @param entryId {number}
     * @returns {Promise<ServiceResponse<boolean>>}
     */
    async leave(entryId) {
        const response = await apiService.deleteData(`/api/Waitlist/${entryId}`);
        return response?.data;
    }

    /**
     * Fetch a waitlist offer by its response token (for the email link landing page)
     * @param token {string}
     * @returns {Promise<ServiceResponse<WaitlistOfferDTO>>}
     */
    async getOffer(token) {
        const response = await apiService.getData(`/api/Waitlist/offers/${token}`);
        return response?.data;
    }

    /**
     * Accept a waitlist offer
     * @param token {string}
     * @returns {Promise<ServiceResponse<WaitlistOfferDTO>>}
     */
    async acceptOffer(token) {
        const response = await apiService.postData(`/api/Waitlist/offers/${token}/accept`, null);
        return response?.data;
    }

    /**
     * Decline a waitlist offer
     * @param token {string}
     * @returns {Promise<ServiceResponse<boolean>>}
     */
    async declineOffer(token) {
        const response = await apiService.postData(`/api/Waitlist/offers/${token}/decline`, null);
        return response?.data;
    }
}